import * as ScoreType from 'constants/ScoreType';
import * as GroupType from 'constants/GroupType';
import * as Period from 'constants/Period';

import * as MatchInfo from 'constants/MatchInfo';

const FOOTBALL_SCORE_MAP = {};
FOOTBALL_SCORE_MAP[Period.NOT_STARTED] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.MATCH_NOT_STARTED,
        main: ScoreType.Match
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.CORNER_GROUP]: {
        main: ScoreType.Corner
    },
    [GroupType.FIRST_PERIOD_CORNER_GROUP]: {
        main: ScoreType.Corner
    },
    [GroupType.YELLOW_CARD_GROUP]: {
        main: ScoreType.YellowCard
    },
    [GroupType.FIRST_PERIOD_YELLOW_CARD_GROUP]: {
        main: ScoreType.YellowCard
    }
};

FOOTBALL_SCORE_MAP[Period.FIRST] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.CORNER_GROUP]: {
        main: ScoreType.Corner
    },
    [GroupType.FIRST_PERIOD_CORNER_GROUP]: {
        main: ScoreType.Corner
    },
    [GroupType.YELLOW_CARD_GROUP]: {
        main: ScoreType.YellowCard
    },
    [GroupType.FIRST_PERIOD_YELLOW_CARD_GROUP]: {
        main: ScoreType.YellowCard
    }
};

FOOTBALL_SCORE_MAP[Period.FIRST_BREAK] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.INTERMISSION,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod]
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.CORNER_GROUP]: {
        main: ScoreType.Corner
    },
    [GroupType.YELLOW_CARD_GROUP]: {
        main: ScoreType.YellowCard
    }
};

FOOTBALL_SCORE_MAP[Period.SECOND] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod]
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.CORNER_GROUP]: {
        main: ScoreType.Corner
    },
    [GroupType.YELLOW_CARD_GROUP]: {
        main: ScoreType.YellowCard
    }
};

FOOTBALL_SCORE_MAP[Period.FULL_TIME] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.FULL_TIME,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
        overtime: ScoreType.Overtime
    },
    [GroupType.FIRST_OVERTIME_GROUP]: {
        main: ScoreType.Match
    },
    [GroupType.SECOND_OVERTIME_GROUP]: {
        main: ScoreType.Match
    }
};

FOOTBALL_SCORE_MAP[Period.FIRST_EXTRA] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
        overtime: ScoreType.ExtraTime
    },
    [GroupType.FIRST_OVERTIME_GROUP]: {
        main: ScoreType.Match
    },
    [GroupType.SECOND_OVERTIME_GROUP]: {
        main: ScoreType.Match
    }
};

FOOTBALL_SCORE_MAP[Period.FIRST_EXTRA_BREAK] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.FIRST_EXTRA_ENDED,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
        overtime: ScoreType.ExtraTime
    },
    [GroupType.SECOND_OVERTIME_GROUP]: {
        main: ScoreType.Match
    }
};

FOOTBALL_SCORE_MAP[Period.SECOND_EXTRA] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
        overtime: ScoreType.ExtraTime
    },
    [GroupType.SECOND_OVERTIME_GROUP]: {
        main: ScoreType.Match
    }
};

FOOTBALL_SCORE_MAP[Period.SECOND_EXTRA_BREAK] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
        overtime: ScoreType.ExtraTime
    },
    [GroupType.SECOND_OVERTIME_GROUP]: {
        main: ScoreType.Match
    }
};

FOOTBALL_SCORE_MAP[Period.PENALTIES] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.PENALTY_SERIES,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.PenaltySeries],
        overtime: ScoreType.ExtraTime
    }
};

FOOTBALL_SCORE_MAP[Period.FINISHED] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.MATCH_FINISHED,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod],
        overtime: ScoreType.ExtraTime
    }
};

export default FOOTBALL_SCORE_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Football/ScoreMap.js